import { render, staticRenderFns } from "./GoodsPrimaryKeyAdd.vue?vue&type=template&id=05445162&scoped=true&"
import script from "./GoodsPrimaryKeyAdd.vue?vue&type=script&lang=js&"
export * from "./GoodsPrimaryKeyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05445162",
  null
  
)

export default component.exports